import React from "react";
import NuotoCorsiSezioni from "../components/corsi_nuoto/NuotoCorsiSezioni";
import CaroselloStandard from "../commons/CaroselloStandard";
import corsi from "../images/Estivi/Copertina.png"
import prezziS from "../images/Estivi/prezzi_estivi_sm.png"
import prezzi from "../images/Estivi/Prezzi.png"
import foto1 from "../images/Estivi/adulti.jpg"
import foto2 from "../images/Estivi/IMG_8471.jpg"
import foto3 from "../images/Estivi/IMG_8604.jpg";
import foto4 from "../images/Estivi/IMG_8954.jpg";
import foto5 from "../images/Estivi/IMG_7566.jpg";
import foto6 from "../images/Estivi/IMG_1743.jpg";

import Titolo from "../commons/Titolo";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import {Link, useNavigate} from "react-router-dom";

import Space from "../commons/Space";
import CosaPortareNuoto from "../components/corsi_nuoto/CosaPortareNuoto";
import GenitoriAttivi from "../commons/GenitoriAttivi";
import FrecciaIndietro from "../commons/FrecciaIndietro";
import SpaceL from "../commons/SpaceL";
import snf from "../images/Nuoto/corsiNuoto/Logo_SNF.jpg";
import fin from "../images/logo/Fin.svg";
import certificato from "../images/Nuoto/corsiNuoto/licenza_snf attestato 2023-2024_page-0001.jpg";
import "../styles/CorsiNuoto.css"
import "../styles/Estivi.css"
import CorsiEstivi from "./CorsiEstivi";
import CorsiEstiviSezioni from "../components/corsi_nuoto/CorsiEstiviSezioni";
import insta from "../icone/icons8-instagram-48.png";
import facebook from "../icone/icons8-facebook-48.png";
import TitoloColore from "../commons/TitoloColore";




function NuotoCorsi() {
    const navigate = useNavigate()

    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo title={"Corsi Estivi"} backgroundImage={corsi}/>

            <div style={{padding: "0 1em 1em 1em"}}>
                <br/>
                <br/>


                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                           <h1 style={{color: "#EC635B"}}>Restate con noi!</h1>
                            <h4>Sono aperte le iscrizioni per i corsi estivi</h4>
                            <br/>
                            <h4>
                                Dal <h3 style={{color: "#EC635B"}}>16 giugno</h3> fino al <h3 style={{color: "#EC635B"}}>25 luglio</h3>
                            </h4>
                            <br/>


                            <h4>Scegli l'attività che preferisci</h4>

                            <h3>
                                Corsi <span style={{color: "#EC635B"}}> nuoto </span>  per tutte le età, <span style={{color: "#EC635B"}}> acquafitness </span> e corsi <span style={{color: "#EC635B"}}>fitness </span> </h3>
                            <br/>
                        </p>
                    </blockquote>
                </figure>
                <SpaceL />

                <CorsiEstiviSezioni />
                <Space />

                <div className="m-auto d-flex flex-row justify-content-center ">
                    <img src={prezzi} className="img-fluid estivi"  alt="..." width="600px" />
                </div>

                <Space />

                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h2 style={{color: "#EC635B"}}>Iscriviti subito</h2>
                            <h1 style={{color: "#EC635B"}}>TI ASPETTIAMO!!</h1>
                            <br/>
                            <p>
                                tel: <span/><a style={{color: "grey"}} href="tel:022401006">02 2401 006</a>

                                <br/>
                                e-mail:   <span/>
                                <a style={{color: "grey"}} title="mailto:info@ilcignosport.it" href="mailto:info@ilcignosport.it">info@ilcignosport.it</a>

                            </p>
                            <br/>
                            Via Fiorani, 74
                            <br/>
                            20099 Sesto San Giovanni (MI)
                            <br/>
                            <br/>
                            <p>
                                <Link to="https://www.instagram.com/centrosportivoilcigno/?hl=it">
                                    <img src={insta}></img>
                                </Link>
                                <Link to="https://www.facebook.com/ilcignosport.it/?locale=it_IT">
                                    <img src={facebook}></img>
                                </Link>
                            </p>

                        </p>
                    </blockquote>
                </figure>


                <Space />
                <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4} foto5={foto5} foto6={foto6} />
                <Space />
            </div>
        </div>
    )
}


export default NuotoCorsi
